export default "__VITE_PUBLIC_ASSET__7f492670__"